import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/live-front_main/apps/live/app/global-error.tsx");
